import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "marginated-form p-fluid p-formgrid p-grid kn-flex p-m-2" }
const _hoisted_2 = {
  key: 0,
  class: "p-field p-col-6"
}
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")

  return (_openBlock(), _createBlock("form", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
      return (_openBlock(), _createBlock(_Fragment, { key: index }, [
        (field.VISIBLE)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_InputText, {
                  class: ["kn-material-input", {
                            'p-invalid': !field.value
                        }],
                  type: field.TYPE === 'Number' ? 'number' : 'text',
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event),
                  modelModifiers: { trim: true },
                  disabled: !field.EDITABLE
                }, null, 8, ["type", "modelValue", "onUpdate:modelValue", "class", "disabled"]),
                _createVNode("label", _hoisted_4, _toDisplayString(field.NAME + ' *'), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}